/*
 * @Author: your name
 * @Date: 2020-04-22 16:31:24
 * @LastEditTime: 2020-08-07 14:55:33
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \finfosoft-auth-web\src\public\url.js
 */
const url = {
  
  globalurl:'http://27.128.233.119:17761/v1',
  //globalurl:'http://127.0.0.1:7001/v1'
};
export default url;
